<section class="container-fluid ms-main-bg py-5">
    <div class="container ms-pg-structure">

        <div class="d-flex-between-mob-column">
            <div>
                <h4 class="large-h">{{'Responsible' | translator}}</h4>
            </div>
            <div>
                <div class="d-flex">
                    <h4 class="large-h ms-ml-08">Steps</h4>
                    <div class="d-flex flex-wrap">
                        <span class="pg-num">01</span>
                        <span class="pg-num-active">02</span>
                        <span class="pg-num">03</span>
                        <span class="pg-num">04</span>
                        <span class="pg-num">05</span>
                        <span class="pg-num">06</span>
                        <span class="pg-num">07</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="white-box">
            <div class="row my-4">
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Name</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">
                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Email</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">

                    </div>
                </div>
                <div class="col-md-4 col-12">
                    <div class="column mx-4 my-2">
                        <h5 class="medium-h">Mobile</h5>
                        <input type="text" class="form-control ms-input" placeholder="for example"
                            id="exampleInputEmail1" aria-describedby="emailHelp">

                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-between">
            <button class="next-btn"><i class="pi pi-arrow-right mx-2"></i>Next</button>
            <button class="submmit-btn">Create</button>
        </div>

        <div class="my-5">
            <h4 class="large-h mb-0 m-top-15">Responsible List</h4>
            <div class="flex-white-box-row-mob white-box-row">
                <div class="d-flex align-items-center mob-column">
                    <div class="d-flex mob-w-100">
                        <div class="number-box">
                            01
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mob-m-t-b-1rem">
                        <div class="detail-box"><i class="pi pi-user icon-ml"></i>Jaxon Lipshutz</div>
                        <div class="detail-box"><i class="fa-regular fa-envelope icon-ml"></i>Pmlemailendor.com</div>
                        <div class="detail-box"><i class="fa-solid fa-phone icon-ml"></i>03123506999</div>
                        <div class="detail-box-purple">Senior Responsible</div>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                </div>
            </div>

            <div class="flex-white-box-row-mob white-box-row">
                <div class="d-flex align-items-center mob-column">
                    <div class="d-flex mob-w-100">
                        <div class="number-box">
                            02
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mob-m-t-b-1rem">
                        <div class="detail-box"><i class="pi pi-user icon-ml"></i>Jaxon Lipshutz</div>
                        <div class="detail-box"><i class="fa-regular fa-envelope icon-ml"></i>Pmlemailendor.com</div>
                        <div class="detail-box"><i class="fa-solid fa-phone icon-ml"></i>03123506999</div>
                        <div class="detail-box-purple-border">Senior Responsible</div>
                    </div>
                </div>
                <div class="d-flex">
                    <div class="circle-btn"><i class="fa fa-trash"></i></div>
                    <div class="circle-btn"><i class="fa fa-pencil"></i></div>
                </div>
            </div>
        </div>

    </div>
</section>